module.exports = __webpack_public_path__ + "img/texture.3b725bb4.png";